import React, { useState } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { Button, HelperText, useTheme } from 'react-native-paper';
import * as Device from 'expo-device';
import PropTypes from 'prop-types';

import WaterUseDataTable from './WaterUseDataTable';
import WaterUseDataChart from './WaterUseDataChart';

function CropWaterUseTable({
  appStyles,
  data,
  irrigation,
  language,
  pageContent,
  unit,
}) {
  const [visible, toggleVisible] = useState(false);

  const { colors } = useTheme();

  const showDialog = () => toggleVisible(true);

  const itemsPerPage = 5;

  return (
    <View style={styles.container}>
      {Platform.OS === 'web' ? (
        <style type="text/css">{`
          div[class^="css-textMultiLine-"], div[class*=" css-textMultiLine-"] {
            overflow: visible;
          }
        `}</style>
      ) : null}
      <Text>{pageContent[0]}</Text>
      <WaterUseDataTable
        crops={data}
        irrigation={irrigation}
        itemsPerPage={itemsPerPage}
        language={language}
        pageContent={irrigation ? pageContent.slice(5) : pageContent.slice(7)}
        unit={unit}
      />
      {irrigation
        ? pageContent.slice(1, 5).map((content, index) => (
            <HelperText key={`helper-${index}`} style={styles.helperText}>
              {content}
            </HelperText>
          ))
        : pageContent.slice(1, 7).map((content, index) => (
            <HelperText key={`helper-${index}`} style={styles.helperText}>
              {content}
            </HelperText>
          ))}
      <WaterUseDataChart
        appStyles={appStyles}
        data={data}
        chartTitles={
          irrigation ? pageContent.slice(2, 5) : pageContent.slice(3, 5)
        }
        irrigation={irrigation}
        language={language}
        toggleVisible={toggleVisible}
        visible={visible}
        unit={unit}
      />
      <Button
        style={appStyles.button}
        labelStyle={appStyles.labelStyle}
        color={colors.primary}
        mode="contained"
        onPress={() => showDialog()}
      >
        {language === 'en'
          ? 'Visualize Results'
          : language === 'es'
          ? 'Visualizar resultados'
          : 'TRANSLATE'}
      </Button>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    margin: 5,
  },
  container: {
    flex: 1,
  },
  helperText: { color: 'rgba(0, 0, 0, 0.6)' },
  link: {
    color: '#555988',
    fontWeight: 'bold',
    marginTop: 15,
    textAlign: 'center',
  },
});

CropWaterUseTable.propTypes = {
  pageContent: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.array,
  irrigation: PropTypes.bool,
  language: PropTypes.string,
  unit: PropTypes.string,
};

export default CropWaterUseTable;
